import { useAccountInfo } from '@/hooks/query/account';
import { switchViewService } from '@/services/swtich-view.service';
import { SiteConfigsSettingsData } from '@nf/types/site';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { siteService } from '@/services/site.service';
import { useTranslations } from 'next-intl';
import { useRewardSystemTrigger } from '@/features/home-page/options';
import { useRouter } from '@/navigation';
import { KafkaNote, PromotionType } from '@nf/utils-common/constants';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';

const EuroCupPromotionBanner = () => {
	const router = useRouter();
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const shortCode = switchViewService.convertLanguageToShortCode(user?.Lang as string, SiteConfigsData as SiteConfigsSettingsData);

	return (
		<div className="home-activity-banner" onClick={() => router.push('/promotion')}>		
			<img src={siteService.combineImagePath(`/images/banner/home/${shortCode}/pm_euro-cup.jpg`, true, SiteConfigsData)} />

		</div>
	)	
}
export const MobileActivities = () => {
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const { triggerWithCare } = useRewardSystemTrigger();
	const { SiteConfigsData } = useGetSiteConfigs();

	const handleClick = () => {
		const kafkaData = {
			note: KafkaNote.Reward,
			type: 4,
			action: 11
		}
		setKafkaNormal(kafkaData);
		triggerWithCare('open-signin');
	}

	return (
		<div className="home-activity">
			{
				(SiteConfigsData?.EnablePromotion === PromotionType.Special && SiteConfigsData?.EnableSingleMatchJackpot) ? <EuroCupPromotionBanner /> : null
			}
			{
				!user?.RewardInfo?.EnableRewardSystem ? null : (
					<div
						className="home-sign"
						onClick={handleClick}
					>
						<div className="home-sign__img" />
						<div className="home-sign__content">
							<div className="home-sign__text">{t('lbl_RPDailycheckin2')}</div>
							<div className="home-sign__text-special">{t('lbl_RPCheckIn')}</div>
							<div className="home-sign__btn">
								<span>{t('lbl_RPGo1')}</span>
							</div>
						</div>
					</div>)
			}
		</div>
	);
}